module.exports = __webpack_public_path__ + "static/img/application.61e97de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneCasePage/application.png
// module id = WJ8W
// module chunks = 0